import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 border-t border-primary-900/60">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-600 flex items-center justify-center text-background-50 text-lg">
                <i className="ri-movie-line" />
              </span>
              <span className="font-heading font-bold text-foreground-50 text-base whitespace-nowrap">
                饥渴的岳中文字幕
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed font-label">
              专注整理《饥渴的岳》系列电影的中文字幕资源，提供剧情介绍、版本索引与便捷浏览体验。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-foreground-50 font-semibold mb-4 text-base">站内导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: "首页", to: "/" },
                { label: "分类浏览", to: "/category" },
                { label: "搜索影片", to: "/search" },
                { label: "关于本站", to: "/about" },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer font-label"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-foreground-50 font-semibold mb-4 text-base">资源分类</h3>
            <ul className="space-y-2.5">
              {["中文字幕BD", "中文字幕4K", "中文字幕DV", "中文字幕合集"].map((item) => (
                <li key={item}>
                  <Link
                    to={`/category?v=${encodeURIComponent(item)}`}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer font-label"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-foreground-50 font-semibold mb-4 text-base">内容说明</h3>
            <p className="text-sm text-foreground-300 leading-relaxed font-label">
              本站为影视内容展示与信息索引站点，播放部分仅作界面演示，不含真实播放接口。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs md:text-sm text-foreground-400 font-label">
            © {year} 饥渴的岳中文字幕 · 本站内容仅供学习与信息参考
          </p>
          <p className="text-xs md:text-sm text-foreground-400 font-label">
            演示站点 · 影片信息均为虚拟内容
          </p>
        </div>
      </div>
    </footer>
  );
}